module.exports = __webpack_public_path__ + "media/images/icons/mapaKriminatlityW-edff85c060dd1995e2cd0d9b6a2422ee.svg";